import de from "./de";

const putDynamicValue = (langString: string, parameters: string[]) => {
  let newString = "";
  for (let i = 0; i < parameters.length; i++) {
    const spatt = new RegExp(`{dval${i + 1}}`);
    if (newString === "") {
      newString = langString.replace(spatt, parameters[i]);
    } else {
      newString = newString.replace(spatt, parameters[i]);
    }
  }
  return newString;
};

const lang = (selector: string, parameters?: string[]) => {
  let langString = de[selector];
  if (!langString) {
    console.log("NOT_FOUND_TRANSLATION_SELECTOR", selector);
    return selector;
  }
  if (parameters && parameters.length > 0) {
    langString = putDynamicValue(langString, parameters);
  }
  return langString;
};

export default lang;
